
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SlideContent from './components/SlideContent';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    { id: 0, title: '首页', type: 'cover' },
    { id: 1, title: '议程', type: 'agenda' },
    { id: 2, title: '第一部分：形势迫人', type: 'situation' },
    { id: 3, title: '第二部分：知己知彼', type: 'customers' },
    { id: 4, title: '第三部分：利器在手', type: 'tools' },
    { id: 5, title: '解决方案一：阿里巴巴B2B', type: 'solution1' },
    { id: 6, title: '解决方案二：亚马逊精品', type: 'solution2' },
    { id: 7, title: '解决方案三：混合模式', type: 'solution3' },
    { id: 8, title: '解决方案四：铺货小包', type: 'solution4' },
    { id: 9, title: '解决方案五：传统外贸', type: 'solution5' },
    { id: 10, title: '第四部分：风险预警', type: 'risks' },
    { id: 11, title: '第五部分：行动建议', type: 'actions' },
    { id: 12, title: '总结与Q&A', type: 'summary' }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Header />
      
      {currentSlide === 0 && <Hero />}
      
      <div className="container mx-auto px-4 py-8">
        <SlideContent 
          slide={slides[currentSlide]} 
          currentSlide={currentSlide}
        />
        
        <Navigation 
          slides={slides}
          currentSlide={currentSlide}
          onNext={nextSlide}
          onPrev={prevSlide}
          onGoTo={goToSlide}
        />
      </div>
      
      <Footer />
    </div>
  );
}
